import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import style from '../../../style/components/profile/emails/EmailTable.module.scss';
import EmailRow from './EmailRow';

const EmailTable = ({
  emails,
  onUseForChange,
  onRemove,
  onResendVerification,
  onSetDefault,
  defaultEmailPending,
  addRowElement,
  otpTargetEmailId,
  otpRowElement,
  justVerifiedEmailId,
  verifiedNotificationElement,
}) => {
  const { t } = useTranslation();

  const renderEmailRow = (email) => (
    <EmailRow
      key={email.email_id}
      email={email}
      onUseForChange={onUseForChange}
      onRemove={onRemove}
      onResendVerification={onResendVerification}
      onSetDefault={onSetDefault}
      defaultEmailPending={defaultEmailPending}
    />
  );

  return (
    <table className={style.table} data-testid="email-table">
      <thead>
        <tr className={style.headerRow}>
          <th className={style.headerCell} scope="col">
            {t('walletEmails.email')}
          </th>
          <th className={style.headerCell} scope="col">
            {t('walletEmails.type')}
          </th>
          <th className={style.headerCell} scope="col">
            {t('walletEmails.useFor')}
          </th>
          <th className={style.headerCell} scope="col">
            {t('walletEmails.status')}
          </th>
          <th className={style.headerCellRight} scope="col">
            {t('walletEmails.action')}
          </th>
        </tr>
      </thead>
      <tbody>
        {emails.map((email) => {
          const isOtpTarget = otpTargetEmailId === email.email_id;
          const isJustVerified =
            justVerifiedEmailId === email.email_id &&
            !!verifiedNotificationElement;
          const rowContent = isOtpTarget
            ? otpRowElement
            : renderEmailRow(email);

          if (!isJustVerified) return rowContent;

          return (
            <React.Fragment key={email.email_id}>
              {rowContent}
              {verifiedNotificationElement}
            </React.Fragment>
          );
        })}
        {!otpTargetEmailId && otpRowElement}
        {addRowElement}
      </tbody>
    </table>
  );
};

EmailTable.propTypes = {
  emails: PropTypes.arrayOf(
    PropTypes.shape({
      email_id: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onUseForChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onResendVerification: PropTypes.func.isRequired,
  onSetDefault: PropTypes.func.isRequired,
  defaultEmailPending: PropTypes.bool,
  addRowElement: PropTypes.node,
  otpTargetEmailId: PropTypes.string,
  otpRowElement: PropTypes.node,
  justVerifiedEmailId: PropTypes.string,
  verifiedNotificationElement: PropTypes.node,
};

export default memo(EmailTable);
